export const can = (user, key) => !!user?.perms?.includes(key);
